import {urlGenerator} from "../../Helper/AxiosHelper";

export default {
    methods: {
        getAction(row, action, active) {
            const baseURL = `${action.url}/${row.id}`;
            if (action.type === 'page') {
                window.location = urlGenerator(`${baseURL}/${action.name}`);
            }

            if (action.name === 'delete') {
                this.delete_url = baseURL
                this.confirmationModalActive = true;
            }
        },
        customAction(row, action) {
            const baseURL = `${action.url}/${row.id}`;
            if (action.name === 'approve') {
                this.reject_url = baseURL;
                this.confirmationModalActive = false;
            }

            if (action.name === 'reject') {
                this.reject_url = baseURL;
                this.confirmationModalActive = false;
            }
        }
    }
}
